import { defineMessages } from "@/i18n";
import en from "./en";

export const framesTaskboardMessages = defineMessages("frames-taskboard", en);
